import store from '@store'
import router from '@router/router'

export default {
  beforeEnter(to, from, next) {
    if (store.state.auth.user) {
      if (store.state.auth.user.needsPasswordChange) {
        // router.push({ name: 'ResetPasswordPage', replace: true })
      } else {
        next()
      }
    }
    store.dispatch('auth/check').then(next, () => {
      next(false)

      to.path === '/'
        ? router.push({ name: 'LoginPage',
          replace: true
        })
        : router.push({ name: 'LoginPage',
          replace: true,
          query: {
            redirect_after_login: encodeURI(location.href.split(location.origin).join(''))
          } })
    })
  }
}



// WEBPACK FOOTER //
// ./src/router/guards/authGuard.js